import React, { ReactElement, useState } from "react";
import * as Popover from "@radix-ui/react-popover";
import classNames from "classnames";
import styles from "./fabButton.module.scss";
import CloseIcon from "@icons/closeIconV2.svg";

type FabButtonProps = {
  href: string;
  image?: string;
  target?: string;
  onClick?: () => void;
  calloutText?: string;
  position?: "left" | "right";
};

export const FabButton = (props: FabButtonProps): ReactElement => {
  const {
    href,
    image,
    target = "_self",
    onClick,
    calloutText,
    position = "right",
  } = props;

  const [open, setOpen] = useState<boolean>(!!calloutText);

  const side: Popover.PopoverContentProps["side"] = "top";
  const align: Popover.PopoverContentProps["align"] =
    position === "left" ? "start" : "end";

  return (
    <div
      className={classNames(styles.container, {
        [styles.left]: position === "left",
        [styles.right]: position !== "left",
      })}
      onClick={onClick}
    >
      <Popover.Root open={!!calloutText && open}>
        <Popover.Anchor asChild>
          <a
            href={href}
            target={target}
            rel={target === "_blank" ? "noopener noreferrer" : undefined}
            className={styles.fabLink}
          >
            {image ? <img src={image} alt="" /> : null}
          </a>
        </Popover.Anchor>

        {calloutText ? (
          <Popover.Portal>
            <Popover.Content
              className={styles.popoverContent}
              side={side}
              align={align}
              sideOffset={10}
              avoidCollisions
            >
              <a
                href={href}
                target={target}
                rel={target === "_blank" ? "noopener noreferrer" : undefined}
                className={styles.calloutTextLabel}
              >
                {calloutText}
              </a>

              <span
                className={styles.closeCalloutButton}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setOpen(false);
                }}
              >
                <CloseIcon width={16} height={16} />
              </span>

              <Popover.Arrow className={styles.popoverArrow} />
            </Popover.Content>
          </Popover.Portal>
        ) : null}
      </Popover.Root>
    </div>
  );
};
